import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
    callId: null,
    callTitle: null,
    payload: null
};

const callOutcomeModalSlice = createSlice({
    name: 'callOutcomeModal',
    initialState,
    reducers: {
        showCallOutcomeModal: (state, action) => {
            const payload = action.payload || {};

            state.isOpen = true;
            state.callId = payload.callId || null;
            state.callTitle = payload.callTitle || null;
            state.payload = payload;
        },
        clearCallOutcomeModal: (state) => {
            state.isOpen = false;
            state.callId = null;
            state.callTitle = null;
            state.payload = null;
        }
    }
});

export const { showCallOutcomeModal, clearCallOutcomeModal } = callOutcomeModalSlice.actions;

export default callOutcomeModalSlice.reducer;
